let mainLangValues = {
    "font_family": {
        "kr": "'Roboto', sans-serif",
        "en": "'Roboto', sans-serif",
        "pt": "'Roboto', sans-serif",
        "tw": "'NotoSansSC', sans-serif",
        "cn": "'NotoSansSC', sans-serif",
        "id": "'OAGothic', sans-serif",
    },
    "language":
    {
        "kr": "한국어",
        "en": "English",
        "pt": "Português",
        "tw": "繁體中文",
        "cn": "简体中文",
        "id": "Indonesian"
    },
    "prereg-1": { "kr": "플레이파크 사전예약 등록하기", "en": "Pre-Register for PlayPark", "pt": "Pré-Registre-se na PlayPark", "cn": "PlayPark事前预约登录", "tw": "PlayPark事前預約登錄", "id": "Daftar untuk pra-registrasi di PlayPark" },
    "prereg-2": { "kr": "플레이파크 로그인", "en": "PlayPark Login", "pt": "Login com PlayPark", "cn": "PlayPark登录", "tw": "PlayPark登錄", "id": "PlayPark Login" },
    "prereg-3": { "kr": "구글 로그인", "en": "Google Login", "pt": "Login com Google", "cn": "谷歌登录", "tw": "谷歌登錄", "id": "Google Login" },
    "prereg-4": { "kr": "페이스북 로그인", "en": "Facebook Login", "pt": "Login com Facebook", "cn": "FACEBOOK登录", "tw": "FACEBOOK登錄", "id": "Facebook Login" },
    "prereg-5": { "kr": "메가수스 사전예약 등록하기", "en": "Pre-Register for Megaxus", "pt": "Pré-Registre-se na Megaxus", "cn": "Megaxus事前预约登录", "tw": "Megaxus事前預約登錄", "id": "Daftar untuk pra-registrasi di Megaxus" },
    "btn-ok": { "kr": "확인", "en": "Confirm", "pt": "Confirmar", "cn": "确认", "tw": "確認", "id": "Konfirmasi" },
    "prereg-6": { "kr": "아이디", "en": "Username", "pt": "Nome de Usuário", "cn": "账号", "tw": "賬號", "id": "ID" },
    "prereg-7": { "kr": "비밀번호", "en": "Password", "pt": "Senha", "cn": "密码", "tw": "密碼", "id": "Password" },

    "key-8": {
        kr: "GrandChase Classic",
        en: "GrandChase Classic",
        pt: "GrandChase Classic",
        cn: "永恒冒险经典版",
        tw: "永恒冒險經典版",
        id: "GrandChase Classic",
    },
    "key-9": {
        kr: "Twitch",
        en: "Twitch",
        pt: "Twitch",
        cn: "Twitch",
        tw: "Twitch",
        id: "Twitch",
    },
    "key-10": {
        kr: "Twitch Drops 시작하기",
        en: "Start Twitch Drops",
        pt: "Começar Drops da Twitch",
        cn: "Twitch Drops 开始使用",
        tw: "Twitch Drops 開始使用",
        id: "Memulai dengan Twitch Drops",
    },
    "key-11": {
        kr: "로그인하기",
        en: "Login",
        pt: "Login",
        cn: "登录",
        tw: "登錄",
        id: "Masuk",
    },
    "key-12": {
        kr: "계정 연동 및 Drops 활성화하기",
        en: "Link Accounts and Activate Drops",
        pt: "Vincular Contas e Ativar Drops",
        cn: "账号绑定及启用 Drops",
        tw: "賬號綁定及啟用 Drops",
        id: "Menautkan akun dan mengaktifkan Drops",
    },
    "key-13": {
        kr: "각 계정에 로그인하여 연동해 주세요",
        en: "Login to each account to link them.",
        pt: "Faça login em cada conta para vincular.",
        cn: "请登录各个账号进行绑定，",
        tw: "請登錄各個賬號進行綁定，",
        id: "Silakan masuk ke setiap akun untuk menautkannya.",
    },
    "key-14": {
        kr: "클릭하여 로그인",
        en: "Click to Login",
        pt: "Clique para Entrar",
        cn: "点击登录",
        tw: "點擊登錄",
        id: "klik untuk login",
    },
    "key-15": {
        kr: "FAQ",
        en: "FAQ",
        pt: "FAQ",
        cn: "FAQ",
        tw: "FAQ",
        id: "FAQ",
    },
    "key-16": {
        kr: "1. 트위치 드롭스란? ",
        en: "1. What are Twitch Drops? ",
        pt: "1. O que são Drops da Twitch?",
        cn: "1.什么是 Twitch Drops？",
        tw: "1.什麽是 Twitch Drops？",
        id: "1. Apa itu Twitch Drops? ",
    },
    "key-17": {
        kr: "트위치 드롭스는 일정 시간 동안 생중계 방송을 시청함으로써 인게임 아이템을 획득할 수 있는 보상입니다.",
        en: "Twitch Drops are rewards that allow players to acquire in-game items by watching live streams for a certain amount of time.",
        pt: "Drops são recompensas que permitem que jogadores adquiram itens no jogo ao assistis livestreams por um certo período de tempo.",
        cn: "Twitch Drops 是一种通过观看直播一段时间来获得游戏内道具的奖励。",
        tw: "Twitch Drops 是一種通過觀看直播一段時間來獲得遊戲內道具的獎勵。",
        id: "Twitch Drops adalah hadiah untuk menonton streaming langsung selama jangka waktu tertentu untuk mendapatkan item dalam game.",
    },
    "key-18": {
        kr: "드롭스 보상은 드롭스가 활성화된 방송을 일정 시간 이상 시청하여 획득할 수 있습니다. ",
        en: "Drops rewards are acquired by watching a stream with Drops enabled for a certain amount of time. ",
        pt: "Drops são adquiridos ao assistir uma livestream com Drops habilitados por um certo período de tempo.",
        cn: "Drops 奖励可以通过观看已启用 Drops 的直播达到指定时间来获得。",
        tw: "Drops 獎勵可以通過觀看已啟用 Drops 的直播達到指定時間來獲得。",
        id: "Hadiah Drops dapat diperoleh dengan menonton siaran yang mendukung Drops selama jangka waktu tertentu. ",
    },
    "key-19": {
        kr: "드롭스 보상을 획득하는 데 필요한 시청 시간은 드롭스 이벤트마다 다릅니다.",
        en: "The amount of watch time required to acquire Drops rewards will differ for each Drops event.",
        pt: "A quantidade de tempo assistido necessária para adquirir recompensas de Drops será diferente para cada evento de Drops.",
        cn: "获取 Drops 奖励所需的观看时间因 Drops 活动而异。",
        tw: "獲取 Drops 獎勵所需的觀看時間因 Drops 活動而異。",
        id: "Durasi waktu menonton yang diperlukan untuk mendapatkan hadiah Drops berbeda-beda menurut event Drops.",
    },
    "key-20": {
        kr: "2. 드롭스 보상은 어떻게 획득하나요? ",
        en: "2. How do I acquire Drops rewards? ",
        pt: "2. Como eu adquiro recompensas de Drops?",
        cn: "2.如何获得 Drops 奖励？",
        tw: "2.如何獲得 Drops 獎勵？",
        id: "2. Bagaimana cara mendapatkan hadiah Drops? ",
    },
    "key-21": { "kr": "1. [로그인하기] 버튼을 클릭하여 그랜드체이스 클래식 계정 로그인", "en": "1. Login to a GrandChase Classic account by clicking the [Login] button", "pt": "1. Faça login numa conta de GrandChase Classic ao clicar no botão [Login]", "cn": "1.点击 [登录] 按钮登录 永恒冒险经典版 账号", "tw": "1.點擊 [登錄] 按鈕登錄 永恒冒險經典版 賬號", "id": "1. Klik tombol [Masuk] untuk login ke akun Grand Chase Classic kamu" },
    "key-22": { "kr": "2. [로그인하기] 버튼을 클릭하여 트위치 계정 로그인", "en": "2. Click the [Login] button to login to a Twitch account", "pt": "2. Clique no botão [Login] para entrar na sua conta da Twitch", "cn": "2.点击 [登录] 按钮登录 Twitch 账号", "tw": "2.點擊 [登錄] 按鈕登錄 Twitch 賬號", "id": "2. klik tombol [Masuk] untuk masuk ke akun Twitch kamu" },
    "key-23": {
        kr: "3. [계정 연동 및 드롭스 활성화하기] 버튼을 클릭하여 연동",
        en: "3. Click the [Link Accounts and Activate Drops] button to link accounts",
        pt: "3. Clique no botão [Vincular Contas e Ativar Drops] para vincular as suas contas",
        cn: "3.点击 [账号绑定及启用 Drops] 按钮进行绑定",
        tw: "3.點擊 [賬號綁定及啟用 Drops] 按鈕進行綁定",
        id: "3. Klik tombol [Aktifkan tautan akun dan Drops] untuk menautkan akun kamu",
    },
    "key-24": {
        kr: "4. 그랜드체이스 클래식, 트위치 연동 확인 후 트위치 페이지로 이동",
        en: "4. Confirm the GrandChase Classic and Twitch connection and go to the Twitch page",
        pt: "4. Confirme o vínculo do GrandChase Classic com a Twitch e vá para a página da Twitch",
        cn: "4.确认 永恒冒险经典版 和 Twitch 绑定成功后，跳转至 Twitch 页面",
        tw: "4.確認 永恒冒險經典版 和 Twitch 綁定成功後，跳轉至 Twitch 頁面",
        id: "4. Konfirmasikan integrasi Grand Chase Classic dan Twitch dan buka halaman Twitch",
    },
    "key-25": {
        kr: "5. 트위치에서 그랜드체이스 클래식 검색",
        en: "5. Search for GrandChase Classic on Twitch",
        pt: "5. Procure GrandChase Classic na Twitch",
        cn: "5.在 Twitch 搜索 永恒冒险经典版",
        tw: "5.在 Twitch 搜索 永恒冒險經典版",
        id: "5. Cari Grand Chase Classic di Twitch",
    },
    "key-26": {
        kr: "6. 생방송 중인 채널 중 방송 제목에 드롭스가 적혀있는 방송 클릭 후 집입",
        en: "6. Click on a livestream that has Drops in the title and join the stream",
        pt: "6. Clique em uma livestream que tenha Drops no título para assistir a livestream",
        cn: "6.在直播中的频道中，点击标题中包含 Drops 的直播",
        tw: "6.在直播中的頻道中，點擊標題中包含 Drops 的直播",
        id: "6. Klik channel yang sedang live dan memiliki Drops di judul siaran dan bergabunglah",
    },
    "key-27": {
        kr: "7. 일정 시간 이상 생방송 시청",
        en: "7. Watch the stream for a certain amount of time",
        pt: "7. Assista a livestream por um certo período de tempo",
        cn: "7.观看直播达到指定时间",
        tw: "7.觀看直播達到指定時間",
        id: "7. Menonton siaran selama jangka waktu tertentu",
    },
    "key-28": {
        kr: "8. 프로필의 드롭스 및 보상 - 인벤토리 페이지에서 시청 시간에 따른 보상 획득",
        en: "8. Acquire rewards based on watch time in the Drops & Rewards - Inventory page of the Profile",
        pt: "8. Adquira recompensas de acordo com o tempo assistido na página Drops & Recompensas - Inventário no seu Perfil",
        cn: "8.在个人资料的 Drops 与奖励 - 库存页面根据观看时间领取奖励",
        tw: "8.在個人資料的 Drops 與獎勵 - 庫存頁面根據觀看時間領取獎勵",
        id: "8. Dapatkan hadiah untuk durasi menonton di halaman Drops and Rewards - Inventory di profil kamu",
    },
    "key-29": {
        kr: "* 일정 시간 시청 후 인벤토리 페이지에서 보상을 수령해야 인게임 우편으로 보상이 지급됩니다.",
        en: "* Rewards must be claimed in the Inventory page after a certain amount of watch time to be sent to the in-game mailbox.",
        pt: "* Recompensas devem ser resgatadas na página do Inventário após um certo período de tempo assistido para serem enviadas ao correio dentro do jogo.",
        cn: "* 观看达到指定时间后，必须在库存页面领取奖励，才能通过游戏内邮件收到奖励。",
        tw: "* 觀看達到指定時間後，必須在庫存頁面領取獎勵，才能通過遊戲內郵件收到獎勵。",
        id: "* Setelah beberapa jam menonton, kamu harus mengklaim hadiah di halaman Inventory untuk menerimanya melalui mail dalam game.",
    },
    "key-30": {
        kr: "* 보상 수령 후 24시간 이내 인게임 우편으로 보상이 지급됩니다.",
        en: "* Rewards will be sent via in-game mail within 24 hours of being claimed.",
        pt: "* Recompensas serão enviadas para o correio dentro do jogo em até 24 horas após o resgate.",
        cn: "* 领取奖励后，游戏内邮件将在 24 小时内发送奖励。",
        tw: "* 領取獎勵後，遊戲內郵件將在 24 小時內發送獎勵。",
        id: "* Hadiah akan dikirim melalui mail dalam game dalam waktu 24 jam.",
    },
    "key-31": {
        kr: "3. 드롭스가 활성화된 방송인지 어떻게 확인할 수 있나요? ",
        en: "3. How can I check if a livestream has Drops activated? ",
        pt: "3. Como descubro se uma livestream tem Drops ativados?",
        cn: "3. 如何确认某个直播已启用 Drops？",
        tw: "3. 如何確認某個直播已啟用 Drops？",
        id: "3. Bagaimana cara mengetahui apakah suatu siaran mengaktifkan Drops? ",
    },
    "key-32": {
        kr: "채널 페이지에서 “드롭활성화됨” 태그를 통해 확인할 수 있습니다.",
        en: "Look for the “Drops Activated” tag on the channel page.",
        pt: "Procure pela tag “Drops Ativados” na página do canal.",
        cn: "可以通过频道页面的 “已启用 Drops” 标签进行确认。 ",
        tw: "可以通過頻道頁面的 “已啟用 Drops” 標簽進行確認。",
        id: "Kamu dapat memeriksanya dengan mencari tag “Drops enabled” di halaman channel.",
    },
    "key-33": {
        kr: "4. 일정 시간 이상 시청했는데도 보상이 누락된 것 같은데 어떻게 해결하나요?",
        en: "4. What do I do if I don't receive my rewards even though I've been watching for a certain amount of time?",
        pt: "4. O que faço se não receber nenhuma recompensa mesmo depois de assistir por um certo período de tempo?",
        cn: "4. 观看了一定时间但未收到奖励，如何解决？",
        tw: "4. 觀看了一定時間但未收到獎勵，如何解決？",
        id: "4. Saya telah menonton lebih dari jangka waktu tertentu, tetapi hadiahnya sepertinya hilang, bagaimana cara memperbaikinya?",
    },
    "key-34": {
        kr: "드롭스를 받지 못했다면 로그아웃 후 다시 접속을 시도해 주세요. 이후에도 동일한 문제가 계속 발생한다면, 아래 상황을 확인해 보세요. ",
        en: "If players haven't received any Drops, please try logging out and logging back in. If the same issue continues to occur, please check the following circumstances. ",
        pt: "Se isso ocorrer, por favor tente desconectar e conectar novamente na sua conta. Se o problema continuar ocorrendo, por favor verifique as seguintes circunstâncias.",
        cn: "如果未收到 Drops 奖励，请尝试注销后重新登录。如果问题仍然存在，请确认以下内容：",
        tw: "如果未收到 Drops 獎勵，請嘗試注銷後重新登錄。如果問題仍然存在，請確認以下內容：",
        id: "Jika kamu tidak menerima drop, logout dan coba login kembali. Jika kamu masih mengalami masalah yang sama, periksa hal berikut ini ",
    },
    "key-35": {
        kr: "- 게임 계정과 트위치 계정이 올바르게 연동되었는지",
        en: "- Connected GrandChase Account and Twitch Account",
        pt: "- Contas do GrandChase e da Twitch Conectadas",
        cn: "- 游戏账号和 Twitch 账号是否正确绑定",
        tw: "- 遊戲賬號和 Twitch 賬號是否正確綁定",
        id: "- Akun game dan Akun Twitch kamu ditautkan dengan benar",
    },
    "key-36": {
        kr: "- 생방송에 드롭스가 활성화되어있는지",
        en: "- Activated Drops in Livestream",
        pt: "- Drops Ativados na Livestream",
        cn: "- 直播是否已启用 Drops",
        tw: "- 直播是否已啟用 Drops",
        id: "- Drops diaktifkan untuk stream kamu",
    },
    "key-37": {
        kr: "- 트위치 인벤토리에 드롭스 보상이 있는지",
        en: "- Drops Reward in Inventory",
        pt: "- Drops & Recompensas no Inventário",
        cn: "- Twitch 库存页面中是否存在 Drops 奖励",
        tw: "- Twitch 庫存頁面中是否存在 Drops 獎勵",
        id: "- Kamu memiliki hadiah Drops di inventory Twitch kamu",
    },
    "key-38": {
        kr: "- 트위치 인벤토리 페이지에서 보상을 수령하였는지",
        en: "- Drops Reward Claimed in the Twitch Inventory Page",
        pt: "- Drops Resgatados na página do Inventário da Twitch",
        cn: "- 是否已在 Twitch 库存页面领取奖励",
        tw: "- 是否已在 Twitch 庫存頁面領取獎勵",
        id: "- Kamu telah mengklaim hadiah di halaman inventory Twitch kamu",
    },
    "key-39": {
        kr: "관련하여 더 많은 도움은 Twitch's Drops 도움말 페이지에서 받을 수 있습니다.",
        en: "For more assistance, please visit Twitch's Drops help page.",
        pt: "Para mais ajuda, por favor visite a página de ajuda de Drops da Twitch.",
        cn: "如果仍有问题，可前往 Twitch 的 Drops 帮助页面获取更多支持。",
        tw: "如果仍有問題，可前往 Twitch 的 Drops 幫助頁面獲取更多支持。",
        id: "Kamu bisa mendapatkan bantuan lebih lanjut tentang hal ini di halaman bantuan Drops Twitch.",
    },
    "key-40": {
        kr: "Twitch에서 드롭스를 찾고 획득하는 방법",
        en: "How to find and claim Drops on Twitch",
        pt: "Onde encontrar e resgatar Drops na Twitch ",
        cn: "Twitch 上如何查找并领取 Drops",
        tw: "Twitch 上如何查找並領取 Drops ",
        id: "Cara menemukan dan mendapatkan Drops di Twitch",
    },
    "key-40-1": {
        kr: "(링크)",
        en: "(link)",
        pt: "(link)",
        cn: "(链接)",
        tw: "(鏈接)",
        id: "(tautan)",
    },
    "key-41": {
        kr: "5. 동일한 트위치 계정에 게임 계정을 여러 개 연결할 수 있나요? <br/>   &nbsp   &nbsp 반대로, 동일한 게임 계정에 트위치 계정을 여러 개 연결할 수 있나요? ",
        en: "5. Can I have multiple game accounts linked to the same Twitch account? Alternatively, can I have multiple Twitch accounts linked to the same game account? ",
        pt: "5. Posso ter mais de uma conta do jogo vinculada com a mesma conta da Twitch? Ou posso ter múltiplas contas da Twitch vinculadas em uma mesma conta do jogo?",
        cn: "5. 是否可以将多个游戏账号绑定到同一个 Twitch 账号？或者将多个 Twitch 账号绑定到同一个游戏账号？",
        tw: "5. 是否可以將多個遊戲賬號綁定到同一個 Twitch 賬號？或者將多個 Twitch 賬號綁定到同一個遊戲賬號？",
        id: "5. Dapatkah saya menautkan beberapa akun game ke akun Twitch yang sama? Sebaliknya, dapatkah saya menautkan beberapa akun Twitch ke akun game yang sama? ",
    },
    "key-42": {
        kr: "트위치 계정 1개에 하나의 게임 계정만 1:1로 연결하여 보상을 수령할 수 있습니다.",
        en: "Only one game account can be linked to one Twitch account on a 1:1 basis to receive rewards.",
        pt: "Apenas uma conta do jogo pode ser vinculada com uma conta da Twitch em uma base de 1:1 para receber recompensas.",
        cn: "一个 Twitch 账号只能绑定一个游戏账号，并进行 1:1 绑定领取奖励。",
        tw: "一個 Twitch 賬號只能綁定一個遊戲賬號，並進行 1:1 綁定領取獎勵。",
        id: "Kamu hanya dapat menautkan satu akun game ke satu akun Twitch dengan perbandingan 1:1 untuk menerima hadiah.",
    },
    "key-43": {
        kr: "동일한 게임 계정과 동일한 트위치 계정은 같은 보상을 한 번만 수령할 수 있습니다.",
        en: "The same game account and Twitch account can only receive each reward once.",
        pt: "A mesma conta do jogo e da Twitch só podem receber cada recompensa uma vez.",
        cn: "同一个游戏账号和 Twitch 账号只能领取相同的奖励一次。",
        tw: "同一個遊戲賬號和 Twitch 賬號只能領取相同的獎勵一次。",
        id: "Akun game yang sama dan akun Twitch yang sama hanya dapat menerima hadiah yang sama sebanyak satu kali.",
    },
    "key-44": {
        kr: "6. 드롭스 계정 연결을 해제하거나 다른 계정으로 변경할 수 있나요? ",
        en: "6. Can I unlink my Drops account or change to a different account? ",
        pt: "6. Posso desvincular minha conta de Drops ou trocar para uma conta diferente?",
        cn: "6. 是否可以解除 Drops 账号绑定或更换账号？",
        tw: "6. 是否可以解除 Drops 賬號綁定或更換賬號？",
        id: "6. Dapatkah saya memutuskan tautan akun Drops saya atau mengganti ke akun lain? ",
    },
    "key-45": {
        kr: "게임 계정에 연동된 트위치 계정 해제는 이벤트 기간 종료 후",
        en: "To disconnect a Twitch account linked to a game account, please contact",
        pt: "Para desconectar uma conta da Twitch vinculada com uma conta do jogo, por favor entre em contato",
        cn: "绑定的 Twitch 账号只能在活动结束后通过",
        tw: "綁定的 Twitch 賬號只能在活動結束後通過",
        id: "Untuk memutuskan akun Twitch kamu yang ditautkan ke akun game kamu, silakan hubungi",
    },
    "key-45-1": {
        kr: "[그랜드체이스 고객센터]",
        en: "[GrandChase Customer Support]",
        pt: "[Consumidor do GrandChase]",
        cn: "[Grand Chase 客服中心]",
        tw: "[Grand Chase 客服中心]",
        id: "[CS Grandchase]",
    },
    "key-45-2": {
        kr: "로 문의해 주시기 바랍니다.",
        en: "after the event ends.",
        pt: "após o fim do evento.",
        cn: "解除绑定。",
        tw: "解除綁定。",
        id: "setelah periode event berakhir.",
    },
    "key-46": {
        kr: "계정 변경을 원하신다면 해제 후 다른 계정으로 다시 연동해 주시기 바랍니다.",
        en: "To change accounts, please disconnect and re-link to a different account.",
        pt: "Para trocar de conta, por favor desconecte e vincule novamente com uma conta diferente.",
        cn: "如果想更换绑定的账号，请先解除绑定后，再绑定其他账号。",
        tw: "如果想更換綁定的賬號，請先解除綁定後，再綁定其他賬號。",
        id: "Jika kamu ingin mengubah akun kamu, silakan putuskan dan tautkan kembali ke akun yang berbeda.",
    },
    "key-47": {
        kr: "7. 트위치 드롭스 관련하여 다른 질문이 있습니다.",
        en: "7. I have other questions about Twitch Drops.",
        pt: "7. Tenho outras perguntas sobre Drops da Twitch.",
        cn: "7. 还有其他关于 Twitch Drops 的问题？",
        tw: "7. 還有其他關於 Twitch Drops 的問題？",
        id: "7. Saya memiliki pertanyaan lain tentang Twitch Drops.",
    },
    "key-48": {
        kr: "그 외 트위치 드롭스 관련 정보는 ",
        en: "For more information on Twitch Drops, please visit ",
        pt: "Para mais informações sobre Drops da Twitch, por favor visite",
        cn: "更多 Twitch Drops 相关信息，请查看 ",
        tw: "更多 Twitch Drops 相關信息，請查看 ",
        id: "Kamu dapat menemukan informasi lebih lanjut tentang Twitch Drops di",
    },
    "key-48-1": {
        kr: "[Twitch's Drops 도움말 페이지]",
        en: "[Twitch's Drops Help Page].",
        pt: "[Página de Ajuda sobre Drops da Twitch].",
        cn: "[Twitch's Drops 帮助页面]。",
        tw: "[Twitch's Drops 幫助頁面]。",
        id: "[halaman bantuan Twitch Drops].",
    },
    "key-48-2": {
        kr: "를 통해 자세히 확인할 수 있습니다.",
        en: "",
        pt: "",
        cn: "",
        tw: "",
        id: "",
    },
    "key-49": {
        kr: "로그인 완료",
        en: "Login Complete",
        pt: "Login Concluído",
        cn: "登录完成",
        tw: "登錄完成",
        id: "Login berhasil",
    },
    "key-50": {
        kr: "계정 연동 및 드롭스 활성화 성공",
        en: "Account Link and Drops Enable Success",
        pt: "Conta Vinculada e Drops Ativados com Sucesso",
        cn: "账号绑定及Drops激活成功",
        tw: "賬號綁定及Drops激活成功",
        id: "Tautan akun dan aktivasi Drops berhasil",
    },
    "key-51": {
        kr: "계정 연동 및 드롭스 활성화 실패",
        en: "Account Link and Drops Enable Failed",
        pt: "Falha ao Vincular Conta e Ativar Drops",
        cn: "账号绑定及Drops激活失败",
        tw: "賬號綁定及Drops激活失敗",
        id: "Tautan akun dan aktivasi Drops gagal",
    },
    "key-52": {
        kr: "드롭이 활성화된 방송을 시청하고 드롭스 보상 받아가세요!",
        en: "Watch streams with Drops enabled and receive rewards!",
        pt: "Assista livestreams com drops ativados para receber recompensas!",
        cn: "观看已启用Drops的直播，领取Drops奖励吧！",
        tw: "觀看已啟用Drops的直播，領取Drops獎勵吧！",
        id: "Tonton streaming yang mendukung Drops dan mulailah mendapatkan Drops!",
    },
    "key-53": {
        kr: "[그랜드체이스 클래식 트위치 페이지]",
        en: "[GrandChase Classic Twitch Webpage]",
        pt: "[Página da Twitch do GrandChase Classic]",
        cn: "[Grand Chase Classic Twitch页面]",
        tw: "[Grand Chase Classic Twitch頁面]",
        id: "[Grand Chase Classic Twitch page]",
    },
    "key-54": {
        kr: "플레이파크 로그인",
        en: "PlayPark Login",
        pt: "Login com PlayPark",
        cn: "PlayPark登录",
        tw: "PlayPark登錄",
        id: "PlayPark Login",
    },
    "key-55": {
        kr: "메가수스 로그인",
        en: "Megaxus Login",
        pt: "Login com Megaxus",
        cn: "Megaxus登录",
        tw: "Megaxus登錄",
        id: "Megaxus Login",
    },
    "key-56": {
        kr: "* 시청 시간 조건이 다른 보상을 트위치 인벤토리에서 한 번에 수령할 경우 하나의 우편으로 지급됩니다.",
        en: "* If players claim all rewards in the Twitch Inventory at different watch times at once, they will receive all rewards in a single mail.",
        pt: "* Se jogadores resgatarem todas as recompensas no Inventário da Twitch com horários assistidos diferentes de uma vez, receberão todas as recompensas de uma vez no correio.",
        cn: "* 不同观看时间条件的奖励在 Twitch 库存中一次性领取时，将通过一封邮件统一发放。",
        tw: "* 不同觀看時間條件的獎勵在 Twitch 庫存中一次性領取時，將通過一封郵件統一發放。",
        id: "* Jika menerima hadiah dengan persyaratan waktu menonton sekaligus yang berbeda dari Inventory Twitch kamu, hadiah tersebut akan dikirim melalui mailbox.",
    },
    "key-57": {
        kr: "* 하나의 우편으로 최대 5개까지 아이템 수령 가능하며, 보상이 6개 이상이라면 우편이 나눠서 발송됩니다.",
        en: "* Up to 5 items can be claimed in a single mail. If there are 6 or more items, some items will be sent on separate mails.",
        pt: "* Até 5 itens podem ser resgatados em um único correio. Se houverem 6 ou mais itens, alguns serão enviados em correios separados.",
        cn: "* 一封邮件最多可领取5个道具，若奖励数量在6个以上，则会拆分为多封邮件发送。",
        tw: "* 一封郵件最多可領取5個道具，若獎勵數量在6個以上，則會拆分為多封郵件發送。",
        id: "* Kamu dapat menerima hingga 5 item dalam satu mail. Jika ada 6 atau lebih hadiah, akan dikirim dalam mail terpisah.",
    },
    "key-58": {
        kr: "* 게임 접속 중 보상을 수령하지 못했다면 종료 후 재실행해주시기 바랍니다.",
        en: "* If you did not receive rewards in the game, please try to re-launch the game.",
        pt: "* Se você não recebeu as recompensas no jogo, por favor tente abrir o jogo novamente.",
        cn: "* 若在游戏中未能成功领取奖励，请关闭游戏后重新启动。",
        tw: "* 若在遊戲中未能成功領取獎勵，請關閉遊戲後重新啟動。",
        id: "* Jika tidak menerima hadiah saat login, silakan keluar dan luncurkan kembali permainan.",
    },

}

export { mainLangValues }